<template>
  <div class="dialog-wrapper" :class="{'show': state == 1, 'hide': state == 2}" ref="dialog" @click.stop="hide()">
    <div class="content" @click.stop>
      <slot></slot>
    </div>
  </div>
</template>
<style lang='scss' scoped>
  @-webkit-keyframes scaleOut {
    from {
      -webkit-transform: scale(1);
      opacity: 1;
    }
    to {
      -webkit-transform: scale(0.8);
      opacity: 0;
    }
  }

  @-webkit-keyframes ScaleIn {
    from {
      -webkit-transform: scale(0.3);
      opacity: 0;
    }
    to {
      -webkit-transform: scale(1);
      opacity: 1;
    }
  }

  .dialog-wrapper {
    position: fixed;
    z-index: 110;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: auto;
    visibility: hidden;

    &.show {
      background-color: rgba(0, 0, 0, 0.65);
      visibility: visible;
    }

    &.show .content {
      -webkit-animation-name: ScaleIn;
      animation-name: ScaleIn;
      -webkit-animation-duration: .25s;
      animation-duration: 0.25s;
      visibility: visible;
    }

    &.hide .content {
      -webkit-animation-name: scaleOut;
      animation-name: scaleOut;
      -webkit-animation-duration: .25s;
      animation-duration: 0.25s;
    }

    .content {
      background-color: #FFFFFF;
      border-radius: 10px;
      z-index: 111;
      visibility: hidden;
    }
  }
</style>
<script>
  function preventDefault (e) {
    e.preventDefault()
  }
  export default {
    data () {
      return {
        state: 0
      }
    },
    methods: {
      show () {
        document.body.classList.add('dialog-open')
        document.addEventListener('touchmove', preventDefault, { passive: false })
        this.state = 1
      },

      hide () {
        document.body.classList.remove('dialog-open')
        this.state = 2

        setTimeout(() => {
          document.removeEventListener('touchmove', preventDefault, { passive: false })
          this.state = 0
        }, 300)
      }
    }
  }
</script>
